var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"viewLogo"}},[_c('vue-typer',{staticClass:"black title",attrs:{"id":"title","text":'sowon choi',"repeat":0,"type-delay":120,"caret-animation":"solid"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }